export function HomeDefault({ ...props }) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 2.66667C10.2038 2.44444 9.79635 2.44444 9.50005 2.66667L2.83338 7.66667C2.46519 7.94281 2.39057 8.46514 2.66672 8.83333C2.94286 9.20152 3.46519 9.27614 3.83338 9L4.16672 8.75V16.6667C4.16672 17.1269 4.53981 17.5 5.00005 17.5H8.33338C8.79362 17.5 9.16672 17.1269 9.16672 16.6667V12.5H10.8334V16.6667C10.8334 17.1269 11.2065 17.5 11.6667 17.5H15C15.4603 17.5 15.8334 17.1269 15.8334 16.6667V8.75L16.1667 9C16.5349 9.27614 17.0572 9.20152 17.3334 8.83333C17.6095 8.46514 17.5349 7.94281 17.1667 7.66667L10.5 2.66667ZM14.1667 7.5L10 4.375L5.83338 7.5V15.8333H7.50005V11.6667C7.50005 11.2064 7.87315 10.8333 8.33338 10.8333H11.6667C12.127 10.8333 12.5 11.2064 12.5 11.6667V15.8333H14.1667V7.5Z"
      />
    </svg>
  );
}
